export const SET_INDEX = 'SET_INDEX';

export const setIndex = (newIndex) => (
  {type: SET_INDEX, payload: newIndex}
)
